import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorDialog } from './ErrorDialog';

/*
 * Error state of a failed loading query. The message appears as a
 * popup (ErrorDialog) with the technical cause behind a collapsible
 * element, and only there — no error text is pushed into the page.
 * Once the popup is closed, all that remains in the region without
 * data is the retry button, if the caller offers a retry.
 */
export function ErrorNotice({ error, onRetry }) {
  const { t } = useTranslation();
  /* the popup speaks once per error: closing it keeps it closed until
     a new failure produces a new error object */
  const [dismissedError, setDismissedError] = useState(null);

  if (error !== dismissedError) {
    return (
      <ErrorDialog
        error={error}
        fallbackKey="error.loadFailed"
        onClose={() => setDismissedError(error)}
        onRetry={onRetry}
      />
    );
  }

  if (!onRetry) return null;
  return (
    <p className="error-notice-retry">
      <button onClick={onRetry}>{t('error.retry')}</button>
    </p>
  );
}
